import { Matrix, Quaternion, Vector3 } from "@babylonjs/core/Maths/math.vector";
import { PmxObject } from "@/Loader/Parser/pmxObject";
export class MmdRuntimeBone {
    linkedBone;
    name;
    parentBone;
    childBones;
    transformOrder;
    flag;
    transformAfterPhysics;
    appendTransformSolver;
    ikSolver;
    morphPositionOffset;
    morphRotationOffset;
    ikRotation;
    localMatrix;
    worldMatrix;
    getAnimatedPositionToRef;
    getAnimatedRotationToRef;
    getAnimationPositionOffsetToRef;
    // public getAnimationRotationOffsetToRef: (target: Quaternion) => Quaternion;
    constructor(babylonBone, boneMetadata) {
        this.linkedBone = babylonBone;
        this.name = boneMetadata.name;
        this.parentBone = null;
        this.childBones = [];
        this.transformOrder = boneMetadata.transformOrder;
        this.flag = boneMetadata.flag;
        this.transformAfterPhysics = (boneMetadata.flag & PmxObject.Bone.Flag.TransformAfterPhysics) !== 0;
        this.appendTransformSolver = null;
        this.ikSolver = null;
        this.morphPositionOffset = Vector3.Zero();
        this.morphRotationOffset = Quaternion.Identity();
        this.ikRotation = null;
        this.localMatrix = Matrix.Identity();
        this.worldMatrix = babylonBone.getFinalMatrix();
        this.getAnimatedPositionToRef = this._getAnimatedPositionToRef;
        this.getAnimatedRotationToRef = this._getAnimatedRotationToRef;
        this.getAnimationPositionOffsetToRef = this._getAnimationPositionOffsetToRef;
        // this.getAnimationRotationOffsetToRef = this._getAnimationRotationOffsetToRef;
    }
    _getAnimatedPositionWithMorphToRef(target) {
        target.copyFrom(this.linkedBone.position);
        return target.addInPlace(this.morphPositionOffset);
    }
    _getAnimatedPositionToRef(target) {
        target.copyFrom(this.linkedBone.position);
        return target;
    }
    _getAnimatedRotationToRef(target) {
        return target.copyFrom(this.linkedBone.rotationQuaternion);
    }
    _getAnimatedRotationWithMorphToRef(target) {
        target.copyFrom(this.linkedBone.rotationQuaternion);
        return target.multiplyInPlace(this.morphRotationOffset);
    }
    static _TempVector3 = new Vector3();
    _getAnimationPositionOffsetToRef(target) {
        target.copyFrom(this.linkedBone.position);
        this.linkedBone.getRestMatrix().getTranslationToRef(MmdRuntimeBone._TempVector3);
        return target.subtractInPlace(MmdRuntimeBone._TempVector3);
    }
    _getAnimationPositionOffsetWithMorphToRef(target) {
        target.copyFrom(this.linkedBone.position);
        target.addInPlace(this.morphPositionOffset);
        this.linkedBone.getRestMatrix().getTranslationToRef(MmdRuntimeBone._TempVector3);
        return target.subtractInPlace(MmdRuntimeBone._TempVector3);
    }
    // a: rest quaternion
    // b: animation quaternion
    // c: animated quaternion
    // a * b = c
    // to get b from a and c:
    // a^-1 * c = b
    // private static readonly _TempQuaternion = new Quaternion();
    // private _getAnimationRotationOffsetToRef(target: Quaternion): Quaternion {
    //     target.copyFrom(this.babylonBone.rotationQuaternion);
    //     Quaternion.FromRotationMatrixToRef(this.babylonBone.getRestMatrix(), MmdRuntimeBone._TempQuaternion).invertInPlace();
    //     return MmdRuntimeBone._TempQuaternion.multiplyInPlace(target);
    // }
    // private _getAnimationRotationOffsetWithMorphToRef(target: Quaternion): Quaternion {
    //     target.copyFrom(this.babylonBone.rotationQuaternion);
    //     target.multiplyInPlace(this.morphRotationOffset);
    //     Quaternion.FromRotationMatrixToRef(this.babylonBone.getRestMatrix(), MmdRuntimeBone._TempQuaternion).invertInPlace();
    //     return MmdRuntimeBone._TempQuaternion.multiplyInPlace(target);
    // }
    enableMorph() {
        this.getAnimatedPositionToRef = this._getAnimatedPositionWithMorphToRef;
        this.getAnimatedRotationToRef = this._getAnimatedRotationWithMorphToRef;
        this.getAnimationPositionOffsetToRef = this._getAnimationPositionOffsetWithMorphToRef;
        // this.getAnimationRotationOffsetToRef = this._getAnimationRotationOffsetWithMorphToRef;
    }
    disableMorph() {
        this.getAnimatedPositionToRef = this._getAnimatedPositionToRef;
        this.getAnimatedRotationToRef = this._getAnimatedRotationToRef;
        this.getAnimationPositionOffsetToRef = this._getAnimationPositionOffsetToRef;
        // this.getAnimationRotationOffsetToRef = this._getAnimationRotationOffsetToRef;
    }
    static _TempRotation = Quaternion.Identity();
    static _TempPosition = Vector3.Zero();
    updateLocalMatrix() {
        const rotation = this.getAnimatedRotationToRef(MmdRuntimeBone._TempRotation);
        if (this.ikRotation !== null) {
            this.ikRotation.multiplyToRef(rotation, rotation);
        }
        const position = this.getAnimatedPositionToRef(MmdRuntimeBone._TempPosition);
        if (this.appendTransformSolver !== null) {
            if (this.appendTransformSolver.affectRotation) {
                rotation.multiplyInPlace(this.appendTransformSolver.appendRotationOffset);
            }
            if (this.appendTransformSolver.affectPosition) {
                position.addInPlace(this.appendTransformSolver.appendPositionOffset);
            }
        }
        Matrix.ComposeToRef(this.linkedBone.scaling, rotation, position, this.localMatrix);
    }
    static _Stack = [];
    updateWorldMatrix() {
        const stack = MmdRuntimeBone._Stack;
        stack.length = 0;
        stack.push(this);
        while (stack.length > 0) {
            const bone = stack.pop();
            const parentBone = bone.parentBone;
            if (parentBone !== null) {
                bone.localMatrix.multiplyToRef(parentBone.worldMatrix, bone.worldMatrix);
            }
            else {
                bone.worldMatrix.copyFrom(bone.localMatrix);
            }
            const childrenBones = bone.childBones;
            for (let i = 0, l = childrenBones.length; i < l; ++i) {
                stack.push(childrenBones[i]);
            }
        }
    }
}
